
<!--address details tab-->
<div>
    <div class="row">
        <div class="col-md-2"></div>
        <div class="col-md-3 flex justify-content-center">
            <ng-select [options]="usersCategory" bindLabel="name" bindValue="id" [(ngModel)]="selectedCategory"
                [groupBy]="'name'" placeholder="Select a Applicant">
            </ng-select>
            <!-- <p-dropdown [options]="usersCategory" [(ngModel)]="selectedCategory" [styleClass]="'custom-dropdown'" [checkmark]="true" optionLabel="name"
                [showClear]="true" placeholder="Select a Applicant" /> -->
        </div>
        <div class="col-md-1"></div>
        <div class="col-md-4 flex justify-content-center">
            <p-dropdown [options]="users" [(ngModel)]="selectedUser" [styleClass]="'custom-dropdown'" [checkmark]="true"
                optionLabel="name" [showClear]="true" placeholder="Select a User" />
        </div>
        <div class="col-md-2"></div>
    </div>

    <div class="details-block mt-2">
        <div class="chk-block">
            <div class="d-flex">
                <strong>Address Details</strong>
            </div>
        </div>
        <div class="allotment-form">
            <form [formGroup]="allotmentForm">
                <app-user-address [customerData]="salesService.currentCustomer"
                    [context]="'allotmentContext'"></app-user-address>
            </form>
        </div>
        <div class="allotment-form">
            <form [formGroup]="allotmentForm">
                <app-bank-Account [customerData]="this.salesService.currentCustomer"></app-bank-Account>
            </form>
        </div>
        <!-- current/permanent address -->
        <!-- <div class="details-block mt-2">
        <div class="headtext">
            <div class="block-header d-flex">
                <strong>Basic Details</strong>
            </div>
        </div>
        <div class="allotment-form">
            <form [formGroup]="allotmentForm">
                        <div class="row" style="padding: 10px;">
                            <div class="form-group col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                <div class="form-group">
                                    <label><strong>Current Address </strong><span
                                            class="formMandatoryInput">*</span></label>
                                    <textarea type="text" id="currentAddress" class="currentAddress"
                                        name="currentAddress" formControlName="currentAddress" class="form-control"></textarea>
                                </div>
                            </div>
                            <div class="form-group col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                <div class="form-group">
                                    <label><strong>Permanent Address </strong><span
                                            class="formMandatoryInput">*</span></label>
                                    <textarea type="text" id="permanentAddress" class="permanentAddress"
                                        name="permanentAddress" formControlName="permanentAddress"
                                        class="form-control"></textarea>
                                </div>
                            </div>
                        </div>
            </form>
        </div>
    </div> -->
        <!-- emergency contact details -->
        <!-- <div class="details-block mt-2">
        <div class="headtext">
            <div class="block-header d-flex">
                <strong>Emergency Contact Details</strong>
            </div>
            <div class="blocks-inner-icon text-end">
                <img src="../../../../../assets/images/document hide icon.svg" (click)="toggleEmergencyDetails()">
            </div>
        </div>
        <div class="allotment-form">
            <form [formGroup]="allotmentForm">
                        <div class="row" style="padding: 10px;">
                            <div class="form-group col-sm-12 col-md-4 col-lg-4 col-xl-4">
                                <div class="form-group">
                                    <label><strong>Name </strong><span
                                            class="formMandatoryInput">*</span></label>
                                    <input type="text" id="emergencyName" class="emergencyName"
                                        name="emergencyName" formControlName="emergencyName" class="form-control" />
                                </div>
                            </div>
                            <div class="form-group col-sm-12 col-md-4 col-lg-4 col-xl-4">
                                <div class="form-group">
                                    <label><strong>Mobile </strong><span
                                            class="formMandatoryInput">*</span></label>
                                    <input type="text" id="emergencyContactNumber" class="emergencyContactNumber"
                                        name="emergencyContactNumber" formControlName="emergencyContactNumber" class="form-control" />
                                </div>
                            </div>
                            <div class="form-group col-sm-12 col-md-4 col-lg-4 col-xl-4">
                                <div class="form-group">
                                    <label><strong>Relation </strong><span
                                            class="formMandatoryInput">*</span></label>
                                    <input type="text" id="emergencyRelation" class="emergencyRelation"
                                        name="emergencyRelation" formControlName="emergencyRelation" class="form-control" />
                                </div>
                            </div>
                        </div>
            </form>
        </div>
    </div> -->
    </div>
</div>
